const errorCode = [
    { HEX: '0x820400E0', DEC: '2181300448', MSG: '服务初始化错误' },
    { HEX: '0x820400E1', DEC: '2181300449', MSG: '服务忙' },
    { HEX: '0x820400E2', DEC: '2181300450', MSG: '请求数据为空' },
    { HEX: '0x820400E3', DEC: '2181300451', MSG: '用户PIN码为空' },
    { HEX: '0x820400E4', DEC: '2181300452', MSG: '服务回包异常' },
    { HEX: '0', DEC: '0', MSG: '正确' },
    { HEX: '0x82040000', DEC: '-2113667072', MSG: '装载动态库错误' },
    { HEX: '0x82040001', DEC: '-2113667071', MSG: '内存分配错误' },
    { HEX: '0x82040002', DEC: '-2113667070', MSG: '读私钥设备错误' },
    { HEX: '0x82040003', DEC: '-2113667069', MSG: '私钥密码错误' },
    { HEX: '0x82040004', DEC: '-2113667068', MSG: '读证书链设备错误' },
    { HEX: '0x82040005', DEC: '-2113667067', MSG: '证书链密码错误' },
    { HEX: '0x82040006', DEC: '-2113667066', MSG: '读证书设备错误' },
    { HEX: '0x82040007', DEC: '-2113667065', MSG: '证书密码错误' },
    { HEX: '0x82040008', DEC: '-2113667064', MSG: '私钥超时' },
    { HEX: '0x82040009', DEC: '-2113667063', MSG: '缓冲区太小' },
    { HEX: '0x8204000A', DEC: '-2113667062', MSG: '初始化环境错误' },
    { HEX: '0x8204000B', DEC: '-2113667061', MSG: '清除环境错误' },
    { HEX: '0x8204000C', DEC: '-2113667060', MSG: '数字签名错误' },
    { HEX: '0x8204000D', DEC: '-2113667059', MSG: '验证签名错误' },
    { HEX: '0x8204000E', DEC: '-2113667058', MSG: '摘要错误' },
    { HEX: '0x8204000F', DEC: '-2113667057', MSG: '证书格式错误' },
    { HEX: '0x82040010', DEC: '-2113667056', MSG: '数字信封错误' },
    { HEX: '0x82040011', DEC: '-2113667055', MSG: '从LDAP获取证书错误' },
    { HEX: '0x82040012', DEC: '-2113667054', MSG: '证书已过期' },
    { HEX: '0x82040013', DEC: '-2113667053', MSG: '获取证书链错误' },
    { HEX: '0x82040014', DEC: '-2113667052', MSG: '证书链格式错误' },
    { HEX: '0x82040015', DEC: '-2113667051', MSG: '验证证书链错误' },
    { HEX: '0x82040016', DEC: '-2113667050', MSG: '证书已废除' },
    { HEX: '0x82040017', DEC: '-2113667049', MSG: 'CRL格式错误' },
    { HEX: '0x82040018', DEC: '-2113667048', MSG: '连接OCSP服务器错误' },
    { HEX: '0x82040019', DEC: '-2113667047', MSG: 'OCSP请求编码错误' },
    { HEX: '0x8204001A', DEC: '-2113667046', MSG: 'OCSP回包错误' },
    { HEX: '0x8204001B', DEC: '-2113667045', MSG: 'OCSP回包格式错误' },
    { HEX: '0x8204001C', DEC: '-2113667044', MSG: 'OCSP回包过期' },
    { HEX: '0x8204001D', DEC: '-2113667043', MSG: 'OCSP回包验证签名错误' },
    { HEX: '0x8204001E', DEC: '-2113667042', MSG: '证书状态未知' },
    { HEX: '0x8204001F', DEC: '-2113667041', MSG: '对称加解密错误' },
    { HEX: '0x82040020', DEC: '-2113667040', MSG: '获取证书信息错误' },
    { HEX: '0x82040021', DEC: '-2113667039', MSG: '获取证书细目错误' },
    { HEX: '0x82040022', DEC: '-2113667038', MSG: '获取证书唯一标识错误' },
    { HEX: '0x82040023', DEC: '-2113667037', MSG: '获取证书扩展项错误' },
    { HEX: '0x82040024', DEC: '-2113667036', MSG: 'PEM编码错误' },
    { HEX: '0x82040025', DEC: '-2113667035', MSG: 'PEM解码错误' },
    { HEX: '0x82040026', DEC: '-2113667034', MSG: '产生随机数错误' },
    { HEX: '0x82040027', DEC: '-2113667033', MSG: 'PKCS12参数错误' },
    { HEX: '0x82040028', DEC: '-2113667032', MSG: '私钥格式错误' },
    { HEX: '0x82040029', DEC: '-2113667031', MSG: '公私钥不匹配' },
    { HEX: '0x8204002A', DEC: '-2113667030', MSG: 'PKCS12编码错误' },
    { HEX: '0x8204002B', DEC: '-2113667029', MSG: 'PKCS12格式错误' },
    { HEX: '0x8204002C', DEC: '-2113667028', MSG: 'PKCS12解码错误' },
    { HEX: '0x8204002D', DEC: '-2113667027', MSG: '非对称加解密错误' },
    { HEX: '0x8204002E', DEC: '-2113667026', MSG: 'OID格式错误' },
    { HEX: '0x8204002F', DEC: '-2113667025', MSG: 'LDAP地址格式错误' },
    { HEX: '0x82040030', DEC: '-2113667024', MSG: 'LDAP地址错误' },
    { HEX: '0x82040031', DEC: '-2113667023', MSG: '连接LDAP服务器错误' },
    { HEX: '0x82040032', DEC: '-2113667022', MSG: 'LDAP绑定错误' },
    { HEX: '0x82040033', DEC: '-2113667021', MSG: '没有OID对应的扩展项' },
    { HEX: '0x82040034', DEC: '-2113667020', MSG: '获取证书级别错误' },
    { HEX: '0x82040035', DEC: '-2113667019', MSG: '读取配置文件错误' },
    { HEX: '0x82040036', DEC: '-2113667018', MSG: '私钥未载入' },
    { HEX: '0x82040037', DEC: '-2113667017', MSG: '私钥密码长度错' },
    { HEX: '0x82040040', DEC: '-2113667008', MSG: '生成密钥对错  ' },
    { HEX: '0x82040041', DEC: '-2113667007', MSG: '获取公钥错' },
    { HEX: '0x82040041', DEC: '-2113667007', MSG: '从私钥获取公钥错' },
    { HEX: '0x82040042', DEC: '-2113667006', MSG: '编码P10错' },
    { HEX: '0x82040043', DEC: '-2113667005', MSG: '解码P10错' },
    { HEX: '0x82040044', DEC: '-2113667004', MSG: '解码NE P10错' },
    { HEX: '0x82040045', DEC: '-2113667003', MSG: '编码证书错' },
    { HEX: '0x82040046', DEC: '-2113667002', MSG: '公钥解码错' },
    { HEX: '0x82040047', DEC: '-2113667001', MSG: '私钥解码错' },
    { HEX: '0x82040049', DEC: '-2113666999', MSG: '获取会话密钥错' },
    { HEX: '0x82040050', DEC: '-2113666992', MSG: '设备端口错误' },
    { HEX: '0x82040051', DEC: '-2113666991', MSG: '没有设备' },
    { HEX: '0x82040052', DEC: '-2113666990', MSG: '设备驱动错' },
    { HEX: '0x82040053', DEC: '-2113666989', MSG: '连接错误' },
    { HEX: '0x82040054', DEC: '-2113666988', MSG: '设备已锁' },
    { HEX: '0x82040055', DEC: '-2113666987', MSG: '获取设备锁次数' },
    { HEX: '0x82040056', DEC: '-2113666986', MSG: '获取设备端口错' },
    { HEX: '0x82040057', DEC: '-2113666985', MSG: '多个设备错误' },
    { HEX: '0x82040058', DEC: '-2113666984', MSG: '自动检测设备错' },
    { HEX: '0x82040059', DEC: '-2113666983', MSG: '设备无法识别' },
    { HEX: '0x8204005A', DEC: '-2113666982', MSG: '未知错误' },
    { HEX: '0x8204005B', DEC: '-2113666981', MSG: '参数错误' },
    { HEX: '0x8204005C', DEC: '-2113666980', MSG: '证书链验证失败' },
    { HEX: '0x8204005D', DEC: '-2113666979', MSG: '印章区没有足够大小' },
    { HEX: '0x8204005E', DEC: '-2113666978', MSG: '修改密码失败' },
    { HEX: '0x8204005F', DEC: '-2113666977', MSG: '请下载最新版协卡助手' },
    { HEX: '0x820400F8', DEC: '-2113666824', MSG: '无效的登录凭证' },
    { HEX: '0x820400F9', DEC: '-2113666823', MSG: '参数错误' },
    { HEX: '0x820400FA', DEC: '-2113666822', MSG: '不是服务器证书' },
    { HEX: '0x820400FB', DEC: '-2113666821', MSG: '登录错误' },
    { HEX: '0x820400FC', DEC: '-2113666820', MSG: '证书验证方式错误' },
    { HEX: '0x820400FD', DEC: '-2113666819', MSG: '随机数验证错误' },
    { HEX: '0x820400FE', DEC: '-2113666818', MSG: '与客户端代理通信' },
    { HEX: '0x82040053', DEC: '-2113666989', MSG: '设备连接错误' },
    { HEX: '0x82040051', DEC: '-2113666991', MSG: '没有设备' },
    { HEX: '0x82050000', DEC: '-2113601536', MSG: '读取文件错误' },
    { HEX: '0x82050001', DEC: '-2113601535', MSG: '密码错误' },
    { HEX: '0x82050002', DEC: '-2113601534', MSG: '操作句柄错误' },
    { HEX: '0x82050003', DEC: '-2113601533', MSG: '缺少ECC KEY错误' },
    { HEX: '0x82050004', DEC: '-2113601532', MSG: 'ECC KEY与算法不匹配' },
    { HEX: '0x82050005', DEC: '-2113601531', MSG: '非法算法错误' },
    { HEX: '0x82050006', DEC: '-2113601530', MSG: '数字签名错误' },
    { HEX: '0x82050007', DEC: '-2113601529', MSG: '摘要错误' },
    { HEX: '0x82050008', DEC: '-2113601528', MSG: '缓冲区太小' },
    { HEX: '0x82050009', DEC: '-2113601527', MSG: '证书格式错误' },
    { HEX: '0x8205000A', DEC: '-2113601526', MSG: '缺少公钥错误' },
    { HEX: '0x8205000B', DEC: '-2113601525', MSG: '验证签名错误' },
    { HEX: '0x8205000C', DEC: '-2113601524', MSG: '产生公私钥对错误' },
    { HEX: '0x8205000D', DEC: '-2113601523', MSG: 'PKCS12编码错误' },
    { HEX: '0x8205000E', DEC: '-2113601522', MSG: 'PKCS12格式错误' },
    { HEX: '0x8205000F', DEC: '-2113601521', MSG: 'PKCS12解码错误' },
    { HEX: '0x82050010', DEC: '-2113601520', MSG: '设置ECC参数错误' },
    { HEX: '0x82050011', DEC: '-2113601519', MSG: '公私钥不匹配错误' },
    { HEX: '0x82050012', DEC: '-2113601518', MSG: 'PKCS10编码错误' },
    { HEX: '0x82050013', DEC: '-2113601517', MSG: 'PKCS10解码错误' },
    { HEX: '0x82050014', DEC: '-2113601516', MSG: '公钥格式错误' },
    { HEX: '0x82050015', DEC: '-2113601515', MSG: 'PKCS10格式错误' },
    { HEX: '0x82050016', DEC: '-2113601514', MSG: '验证PKCS10错误' },
    { HEX: '0x82050017', DEC: '-2113601513', MSG: 'ECC KEY格式错误' },
    { HEX: '0x82050018', DEC: '-2113601512', MSG: '公钥解码错误' },
    { HEX: '0x82050019', DEC: '-2113601511', MSG: '签名格式错误' },
    { HEX: '0x8205001A', DEC: '-2113601510', MSG: 'EC格式错误' },
    { HEX: '0x8205001B', DEC: '-2113601509', MSG: 'ECC KEY解码错误' },
    { HEX: '0x8205001C', DEC: '-2113601508', MSG: '写入文件错误' },
    { HEX: '0x8205001D', DEC: '-2113601507', MSG: '证书链非法错误' },
    { HEX: '0x8205001E', DEC: '-2113601506', MSG: '内存分配错误' },
    { HEX: '0x8205001F', DEC: '-2113601505', MSG: '初始化环境错误' },
    { HEX: '0x82050020', DEC: '-2113601504', MSG: '读取配置文件错误' },
    { HEX: '0x82050021', DEC: '-2113601503', MSG: '打开设备错误' },
    { HEX: '0x82050022', DEC: '-2113601502', MSG: '打开会话错误' },
    { HEX: '0x82050023', DEC: '-2113601501', MSG: '装载动态库错误' },
    { HEX: '0x82050024', DEC: '-2113601500', MSG: '设备类型错误' },
    { HEX: '0x82050025', DEC: '-2113601499', MSG: '不支持的算法' },
    { HEX: '0x82050026', DEC: '-2113601498', MSG: '产生PKCS10错误' },
    { HEX: '0x82050027', DEC: '-2113601497', MSG: '导出公钥错误' },
    { HEX: '0x82050028', DEC: '-2113601496', MSG: 'EC_POINT非法错误' },
    { HEX: '0x82050029', DEC: '-2113601495', MSG: '对称加密错误' },
    { HEX: '0x8205002A', DEC: '-2113601494', MSG: '对称解密错误' },
    { HEX: '0x8205002B', DEC: '-2113601493', MSG: 'PEM解码错误' },
    { HEX: '0x8205002C', DEC: '-2113601492', MSG: '获取证书细目错误' },
    { HEX: '0x8205002D', DEC: '-2113601491', MSG: 'PEM编码错误' },
    { HEX: '0x8205002E', DEC: '-2113601490', MSG: '获取证书扩展项错误' },
    { HEX: '0x8205002F', DEC: '-2113601489', MSG: '非法接口类型错误' },
    { HEX: '0x82050030', DEC: '-2113601488', MSG: '非法参数错误' },
    { HEX: '0x82050031', DEC: '-2113601487', MSG: '枚举设备错误' },
    { HEX: '0x82050032', DEC: '-2113601486', MSG: '没有设备' },
    { HEX: '0x82050033', DEC: '-2113601485', MSG: '设备连接错误' },
    { HEX: '0x82050034', DEC: '-2113601484', MSG: '产生随机数错误' },
    { HEX: '0x82050035', DEC: '-2113601483', MSG: '导入明文会话密钥错' },
    { HEX: '0x82050036', DEC: '-2113601482', MSG: '对称加密初始化错误' },
    { HEX: '0x82050037', DEC: '-2113601481', MSG: '对称加密错误' },
    { HEX: '0x82050038', DEC: '-2113601480', MSG: '设备管理员口令错误' },
    { HEX: '0x82050039', DEC: '-2113601479', MSG: '打开应用错误' },
    { HEX: '0x8205003A', DEC: '-2113601478', MSG: '设备已锁' },
    { HEX: '0x8205003B', DEC: '-2113601477', MSG: '设备口令错误' },
    { HEX: '0x8205003C', DEC: '-2113601476', MSG: '枚举应用错误' },
    { HEX: '0x8205003D', DEC: '-2113601475', MSG: '删除应用错误' },
    { HEX: '0x8205003E', DEC: '-2113601474', MSG: '创建应用错误' },
    { HEX: '0x8205003F', DEC: '-2113601473', MSG: '创建容器错误' },
    { HEX: '0x82050040', DEC: '-2113601472', MSG: '设备不支持错误' },
    { HEX: '0x82050041', DEC: '-2113601471', MSG: '打开容器错误' },
    { HEX: '0x82050042', DEC: '-2113601470', MSG: '导出公钥错误' },
    { HEX: '0x82050046', DEC: '-2113601466', MSG: '对称加密错误' },
    { HEX: '0x82050047', DEC: '-2113601465', MSG: '导入密钥对错误' },
    { HEX: '0x82050048', DEC: '-2113601464', MSG: '修改设备口令错误' },
    { HEX: '0x82050049', DEC: '-2113601463', MSG: '导入证书错误' },
    { HEX: '0x8205004A', DEC: '-2113601462', MSG: '请确认Ukey中是否有SM2证书' },
    { HEX: '0x8205004B', DEC: '-2113601461', MSG: '创建文件错误' },
    { HEX: '0x8205004C', DEC: '-2113601460', MSG: '写入文件错误' },
    { HEX: '0x8205004D', DEC: '-2113601459', MSG: '获取文件信息错误' },
    { HEX: '0x8205004E', DEC: '-2113601458', MSG: '读取文件错误' },
    { HEX: '0x8205004F', DEC: '-2113601457', MSG: '获取公钥错误' },
    { HEX: '0x82050052', DEC: '-2113601454', MSG: '生成密钥对错误' },
    { HEX: '0x82050053', DEC: '-2113601453', MSG: '证书已过期' },
    { HEX: '0x82050054', DEC: '-2113601452', MSG: '多个设备错误' },
    { HEX: '0x82050055', DEC: '-2113601451', MSG: '没有设备' },
    { HEX: '0x82050056', DEC: '-2113601450', MSG: '自动检测设备错误' },
    { HEX: '0x82050057', DEC: '-2113601449', MSG: '设备无法识别' },
    { HEX: '0x82050058', DEC: '-2113601448', MSG: '获取会话密钥错' },
    { HEX: '0x82050059', DEC: '-2113601447', MSG: '导入会话密钥错' },
    { HEX: '0x8205005A', DEC: '-2113601446', MSG: '初始化摘要错误' },
    { HEX: '0x8205005B', DEC: '-2113601445', MSG: '更新摘要错误' },
    { HEX: '0x8205005C', DEC: '-2113601444', MSG: '生成会话密钥错' },
    { HEX: '0x8205005E', DEC: '-2113601442', MSG: '导入会话密钥错' },
    { HEX: '0x8205005F', DEC: '-2113601441', MSG: '缓冲区太小' },
    { HEX: '0x82050060', DEC: '-2113601440', MSG: 'P7签名数据初始化错误' },
    { HEX: '0x82050061', DEC: '-2113601439', MSG: '产生随机数错误' },
    { HEX: '0x82050062', DEC: '-2113601438', MSG: '对称加密错误' },
    { HEX: '0x82050063', DEC: '-2113601437', MSG: '对称解密错误' },
    { HEX: '0x82050064', DEC: '-2113601436', MSG: '导出公钥错误' },
    { HEX: '0x82050065', DEC: '-2113601435', MSG: '添加p7算法错误' },
    { HEX: '0x82050066', DEC: '-2113601434', MSG: 'P7数据处理错误' },
    { HEX: '0x82050067', DEC: '-2113601433', MSG: '添加P7接受者出错' },
    { HEX: '0x82050068', DEC: '-2113601432', MSG: '签名数据错误' },
    { HEX: '0x82050069', DEC: '-2113601431', MSG: '摘要数据处理错误' },
    { HEX: '0x8205006A', DEC: '-2113601430', MSG: '加密更新错误' },
    { HEX: '0x8205006B', DEC: '-2113601429', MSG: '加密处理错误' },
    { HEX: '0x8205006C', DEC: '-2113601428', MSG: '解密初始化错误' },
    { HEX: '0x8205006D', DEC: '-2113601427', MSG: '解密更新错误' },
    { HEX: '0x8205006E', DEC: '-2113601426', MSG: '解密处理错误' },
    { HEX: '0x8205006F', DEC: '-2113601425', MSG: 'P7格式错误' },
    { HEX: '0x82050070', DEC: '-2113601424', MSG: '导出P7接受者信息错误' },
    { HEX: '0x82050071', DEC: '-2113601423', MSG: '非法的对称算法' },
    { HEX: '0x82050072', DEC: '-2113601422', MSG: '私钥长度错误' },
    { HEX: '0x82050073', DEC: '-2113601421', MSG: 'P7签名错误' },
    { HEX: '0x82050074', DEC: '-2113601420', MSG: '验证P7签名错误' },
    { HEX: '0x82050075', DEC: '-2113601419', MSG: 'P7签名设置版本错误' },
    { HEX: '0x82050076', DEC: '-2113601418', MSG: '锁设备错误' },
    { HEX: '0x82050077', DEC: '-2113601417', MSG: '缓冲区太小' },
    { HEX: '0x82050078', DEC: '-2113601416', MSG: '从LDAP获取证书错误' },
    { HEX: '0x82050079', DEC: '-2113601415', MSG: '连接OCSP服务器错误' },
    { HEX: '0x8205007A', DEC: '-2113601414', MSG: '参数错误' },
    { HEX: '0x8205007B', DEC: '-2113601413', MSG: 'CRL格式错误' },
    { HEX: '0x8205007C', DEC: '-2113601412', MSG: '证书废除' },
    { HEX: '0x8205007D', DEC: '-2113601411', MSG: '证书链格式错误' },
    { HEX: '0x8205007E', DEC: '-2113601410', MSG: '验证证书链错误' },
    { HEX: '0x8205007F', DEC: '-2113601409', MSG: '管理员密码错误' },
    { HEX: '0x82050080', DEC: '-2113601408', MSG: '设备标签格式错误' },
    { HEX: '0x82050081', DEC: '-2113601407', MSG: '删除容器错误' },
    { HEX: '0x82050082', DEC: '-2113601406', MSG: '枚举文件错误' },
    { HEX: '0x82050083', DEC: '-2113601405', MSG: '删除文件错误' },
    { HEX: '0x82050084', DEC: '-2113601404', MSG: '枚举容器错误' },
    { HEX: '0x82050085', DEC: '-2113601403', MSG: '关闭应用错误' },
    { HEX: '0x82050086', DEC: '-2113601402', MSG: '证书状态未知' },
];

const getMsg = (code = '', isDec = false) => {
    let result = errorCode.find(error => {
        if (isDec ? error.DEC === code.toString() : parseInt(error.HEX, 16) === code) {
            return error;
        }
    });
    return result && result.MSG || 'UKEY未知错误';
};

export default getMsg;